import {
  createReportContext,
  type InferReport,
} from "../context/ReportContext";

export type ReferralLinkBaseRecord = {
  id: string;
  name: string;
  shortLink: string;
  fullLink: string;
  tuneLandingPageName: string;
  language: string;
  rebateProgram: string;
  createdAt: string;
  lastClickedAt?: string | null;
};

export const createReferralLinksTableContext = <
  T extends ReferralLinkBaseRecord,
>() => {
  const ctx = createReportContext({
    destinationPages: "multi",
    languages: "multi",
    rebatePrograms: "multi",
    campaigns: "multi",
  })<
    {
      destinationPages: string;
      languages: string;
      rebatePrograms: string;
      campaigns: string;
    },
    {
      table: {
        referralLinks: T[];
        totalCount: number;
      };
      csv: void;
    },
    {
      selected: {
        destinationPages: string[] | null;
        languages: string[] | null;
        rebatePrograms: string[] | null;
        campaigns: string[] | null;
      };
      search: string;
      page: number;
      pageSize: number;
      sortColumn: string | null;
      sortDesc: boolean | null;
    }
  >();

  return {
    Provider: ctx.Provider,
    useReportContext: ctx.useReportContext,
    _ctx: ctx,
  };
};

export type ReferralLinksTableContext<T extends ReferralLinkBaseRecord> =
  ReturnType<typeof createReferralLinksTableContext<T>>;

export type ReferralLinksTableParams<T extends ReferralLinkBaseRecord> =
  InferReport<ReferralLinksTableContext<T>["_ctx"], "params">;

export type ReferralLinksTableStates<T extends ReferralLinkBaseRecord> =
  InferReport<ReferralLinksTableContext<T>["_ctx"], "states">;
